<template>
    <Modal v-model="show"
        title="预售送货单质检"
        :width="1200"
        :footer-hide="true"
        @on-visible-change="onShowChange">
        <Spin v-if="innerSpin"
            size="large"
            fix></Spin>
        <Card :padding="0"
            :bordered="false"
            :dis-hover="true">
            <Row :gutter="16">
                <Col span="24">
                <Form ref="deliveryForm"
                    label-position="top">

                    <Row :gutter="16">
                        <Col span="4">
                        <FormItem label="定单编号">
                            <Input :value="preSaleDeliveryRecord.preSaleOrderRecordCode"
                                readonly></Input>
                        </FormItem>
                        </Col>

                        <Col span="4">
                        <FormItem label="会员名称">
                            <Input :value="preSaleDeliveryRecord.preSaleRecordOwnerName"
                                readonly></Input>
                        </FormItem>
                        </Col>

                        <Col span="4">
                        <FormItem label="会员电话">
                            <Input :value="preSaleDeliveryRecord.preSaleRecordOwnerPhone"
                                readonly></Input>
                        </FormItem>
                        </Col>

                        <Col span="4">
                        <FormItem label="送货单编号">
                            <Input :value="preSaleDeliveryRecord.preSaleDeliveryRecordCode"
                                readonly></Input>
                        </FormItem>
                        </Col>

                        <Col span="4">
                        <FormItem label="送货总量">
                            <Input :value="preSaleDeliveryRecord.preSaleDeliveryRecordTotalQuantity"
                                readonly></Input>
                        </FormItem>
                        </Col>

                        <Col span="4">
                        <FormItem label="送货日期">
                            <Input :value="formatDateString(preSaleDeliveryRecord.preSaleDeliveryRecordDeliveryDate)"
                                readonly></Input>
                        </FormItem>
                        </Col>
                    </Row>

                    <Row :gutter="16">
                        <Col span="4">
                        <FormItem label="物流公司">
                            <Input :value="preSaleDeliveryRecord.preSaleDeliveryRecordLogisticsCompanyName"
                                readonly></Input>
                        </FormItem>
                        </Col>

                        <Col span="8">
                        <FormItem label="备注">
                            <Input :value="preSaleDeliveryRecord.preSaleDeliveryRecordRemark"
                                readonly></Input>
                        </FormItem>
                        </Col>

                        <Col span="4">
                        <FormItem label="制单时间">
                            <Input :value="formatDateTimeString(preSaleDeliveryRecord.preSaleDeliveryRecordCreateAt)"
                                readonly></Input>
                        </FormItem>
                        </Col>

                        <Col span="4">
                        <FormItem label="制单人">
                            <Input :value="preSaleDeliveryRecord.preSaleDeliveryRecordOwnerName"
                                readonly></Input>
                        </FormItem>
                        </Col>

                        <Col span="3">
                        <FormItem label="质检图片">
                            <image-cut v-model="uploadImageFile"
                                button-type="warning" />
                        </FormItem>
                        </Col>
                    </Row>

                    <Row :gutter="16">
                        <Col span="24">
                        <Table ref="productTable"
                            size='small'
                            :columns="productTable.columns"
                            :data="preSaleDeliveryDetails"
                            highlight-row
                            stripe
                            border />
                        </Col>
                    </Row>

                    <Row :gutter="16"
                        class="row-margin-top-10"
                        style="margin-top:10px;text-align:right;">
                        <Col v-if="preSaleDeliveryRecord.preSaleDeliveryRecordDistributionStationCheckStatus === CHECK_STATUS_TYPE_UN_CHECK"
                            span="24">
                        <Button type="primary"
                            @click="onSubmit">质检提交</Button>
                        </Col>
                    </Row>

                </Form>
                </Col>
            </Row>
        </Card>
    </Modal>

</template>

<script>
import { formatDateString, formatDateTimeString } from '@/libs/logic';
import DecimalInput from '@/components/number-input/decimal-input';
import ImageCut from '@/components/image-cut/ImageCut';
import { CHECK_STATUS_TYPE_UN_CHECK } from '@/view/distributionStation-management/distributionStation-delivery-check/DistributionStationDeliveryCheckType';

import { getPreSaleDeliveryRecord } from '@/api/modules/preSale-management/preSale-delivery';
import { saveDistributionStationPreSaleDeliveryCheck } from '@/api/modules/distributionStation-management/distributionStation-delivery-check';

export default {
    name: 'PreDistributionStationDeliveryCheckEdit',
    components: {
        ImageCut
    },
    data() {
        return {
            show: false,
            innerSpin: false,
            recordUuid: '',
            CHECK_STATUS_TYPE_UN_CHECK,
            preSaleDeliveryRecordUuid: '',
            preSaleDeliveryRecord: {
                preSaleOrderRecordCode: '',
                preSaleDeliveryRecordCode: '',
                preSaleDeliveryRecordTotalQuantity: 0,
                preSaleDeliveryRecordDeliveryDate: '',
                preSaleDeliveryRecordCreateAt: '',
                preSaleDeliveryRecordOwnerName: '',
                preSaleDeliveryRecordLogisticsCompanyName: '',
                preSaleDeliveryRecordStartAreaName: '',
                preSaleDeliveryRecordRemark: '',
                preSaleDeliveryRecordDistributionStationCheckStatus: ''
            },
            preSaleDeliveryDetails: [],
            productTable: {
                columns: [
                    { title: '产品编码', key: 'preSaleOrderDetailProductCode', align: 'center' },
                    { title: '产品名称', key: 'preSaleOrderDetailProductName', align: 'center' },
                    { title: '单位', key: 'preSaleOrderDetailProductUnit', align: 'center' },
                    { title: '周次', key: 'preSaleOrderDetailWeekKnownText', align: 'center' },
                    // { title: '下单量', key: 'preSaleOrderDetailOrderQuantity', align: 'center' },
                    { title: '确认价格', key: 'preSaleDeliveryDetailActProductPrice', align: 'center' },
                    { title: '确认金额', key: 'preSaleDeliveryDetailActProductCost', align: 'center' },
                    { title: '送货量', key: 'preSaleDeliveryDetailQuantity', align: 'center' },
                    { title: '转运站收货量', key: 'preSaleDeliveryDetailConfirmQuantity', align: 'center' },
                    {
                        title: '质量问题',
                        key: 'qualifyFailQuantity',
                        align: 'center',
                        render: (h, params) => {
                            if (this.preSaleDeliveryRecord.preSaleDeliveryRecordDistributionStationCheckStatus === CHECK_STATUS_TYPE_UN_CHECK) {
                                return h(DecimalInput, {
                                    props: {
                                        value: params.row.qualifyFailQuantity,
                                        max: params.row.preSaleDeliveryDetailQuantity,
                                        size: 'small',
                                        precision: 0
                                    },
                                    on: {
                                        change: newVal => {
                                            this.preSaleDeliveryDetails[params.index].qualifyFailQuantity = newVal;
                                            this.preSaleDeliveryDetails[params.index].preSaleDeliveryDetailConfirmQuantity
                                                = this.preSaleDeliveryDetails[params.index].preSaleDeliveryDetailQuantity
                                                - this.preSaleDeliveryDetails[params.index].qualifyFailQuantity
                                                - this.preSaleDeliveryDetails[params.index].logisticsFailQuantity;
                                        }
                                    }
                                });
                            }
                            else {
                                this.preSaleDeliveryDetails[params.index].preSaleDeliveryDetailConfirmQuantity
                                    = this.preSaleDeliveryDetails[params.index].preSaleDeliveryDetailQuantity
                                    - this.preSaleDeliveryDetails[params.index].distributionStationProductCheckJournalQualifyFailQuantity
                                    - this.preSaleDeliveryDetails[params.index].distributionStationProductCheckJournalLogisticsFailQuantity;
                                return h('div', [
                                    h('span', params.row.distributionStationProductCheckJournalQualifyFailQuantity)
                                ]);
                            }
                        }
                    },
                    {
                        title: '物流责任',
                        key: 'logisticsFailQuantity',
                        align: 'center',
                        render: (h, params) => {
                            if (this.preSaleDeliveryRecord.preSaleDeliveryRecordDistributionStationCheckStatus === CHECK_STATUS_TYPE_UN_CHECK) {
                                return h(DecimalInput, {
                                    props: {
                                        value: params.row.logisticsFailQuantity,
                                        max: params.row.preSaleDeliveryDetailQuantity,
                                        size: 'small',
                                        precision: 0
                                    },
                                    on: {
                                        change: newVal => {
                                            this.preSaleDeliveryDetails[params.index].logisticsFailQuantity = newVal;
                                            this.preSaleDeliveryDetails[params.index].preSaleDeliveryDetailConfirmQuantity
                                                = this.preSaleDeliveryDetails[params.index].preSaleDeliveryDetailQuantity
                                                - this.preSaleDeliveryDetails[params.index].qualifyFailQuantity
                                                - this.preSaleDeliveryDetails[params.index].logisticsFailQuantity;
                                        }
                                    }
                                });
                            }
                            else {
                                return h('div', [
                                    h('span', params.row.distributionStationProductCheckJournalLogisticsFailQuantity)
                                ]);
                            }
                        }
                    }
                ]
            },
            uploadImageFile: ''
        };
    },
    mounted() {

    },
    methods: {
        onShowChange(e) {
            if (e) {
                this.init();
            }
        },
        showModal(recordUuid) {
            this.recordUuid = recordUuid;
            this.show = true;
        },
        init() {
            // const query = this.$route.query;
            if (this.recordUuid) {
                this.preSaleDeliveryRecordUuid = this.recordUuid;

                this.innerSpin = true;
                getPreSaleDeliveryRecord(this.preSaleDeliveryRecordUuid).then(res => {
                    this.innerSpin = false;
                    if (res.code === 0) {
                        this.preSaleDeliveryRecord = Object.assign(this.preSaleDeliveryRecord, res.data.preSaleDeliveryRecord);
                        this.preSaleDeliveryDetails = res.data.preSaleDeliveryDetails.map(item => {
                            return Object.assign(item, {
                                qualifyFailQuantity: 0,
                                logisticsFailQuantity: 0,
                                preSaleDeliveryDetailConfirmQuantity: item.preSaleDeliveryDetailQuantity,
                                remark: ''
                            });
                        });
                    }
                }).catch(() => {
                    this.innerSpin = false;
                });
            }
        },
        formatDateString,
        formatDateTimeString,
        onSubmit() {
            const hasUnqualifiedQuantity = this.preSaleDeliveryDetails.find(item => item.qualifyFailQuantity > 0);
            if (hasUnqualifiedQuantity) {
                this.$Modal.confirm({
                    title: '有质检不合格的产品，确认提交？',
                    onOk: () => {
                        this.actSubmit();
                    }
                });
            }
            else {
                this.actSubmit();
            }
        },
        actSubmit() {
            const submitData = {
                preSaleDeliveryRecordUuid: this.preSaleDeliveryRecordUuid,
                checkItems: this.preSaleDeliveryDetails.map(item => {
                    return {
                        preSaleDeliveryDetailUuid: item.preSaleDeliveryDetailUuid,
                        qualifyFailQuantity: item.qualifyFailQuantity,
                        logisticsFailQuantity: item.logisticsFailQuantity,
                        remark: ''
                    };
                }),
                checkImage: this.uploadImageFile
            };

            this.innerSpin = true;
            saveDistributionStationPreSaleDeliveryCheck(submitData).then(res => {
                this.innerSpin = false;

                if (res.code === 0) {
                    this.$Modal.success({
                        title: '保存成功',
                        onOk: () => {
                            this.show = false;
                            this.$parent.init();
                        }
                    });
                }
            });
        }
    }
};
</script>

<style scoped>
</style>
